
    import {computed, ComputedRef, defineComponent, reactive, onMounted} from 'vue'
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";
    import pageTitle from "@/views/h5/_components/pageTitle.vue";
    import photoListAll from "@/views/h5/photoListAll.vue"

    interface Tab {
        name: string;
        num: number;
        id: string;
        photoList: Array<any>;
    }

    interface Photo {
        photoIdStr: string;
        smallPhotoUrl: string;
        photoName: string;
    }

    interface State {
        clientHeight: number; // 当前视窗高度
        modelName: string; // 车型名称
        listTab: Array<Tab>; // 照片类型分组
        actTab: string; // 当前查看照片分组id
        photoList: Array<Photo>; // 当前展示的照片列表
        isShowSwiper: boolean; // 是否展示轮播图组件
        backFun: string; // 导航返回点击方法
        swiperPhotoList: Array<Photo>; // 展示轮播图时的照片合集
        initialSlide: number; // 设定初始化时slide的索引
        isAll: boolean; // 是否显示全部黑色背景
    }

    export default defineComponent({
        name: "photoList",
        setup() {
            let state: State = reactive({
                clientHeight: 0,
                modelName: '',
                listTab: [],
                actTab: 'basePhoto',
                photoList: [],
                isShowSwiper: false,
                backFun:'',
                swiperPhotoList: [],
                initialSlide: 0,
                isAll: false
            })
            function urlConversion(path) {
                let reg = /^(https?:\/\/)([0-9a-z.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/i
                path = path.replace(reg, "https://$2$3$4$5$6");
                return path
            }
            const {query} = useRoute();
            const store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            const {photoList, paintPhotoList, markPhotoList, modelName} = dataInfo.value as any
            // title展示文字
            if (`${query.isAll}` === 'total') {
                state.modelName = '附加照片';
            } else {
                state.modelName = modelName;
                state.isAll = true
                state.isShowSwiper = true
            }
            if (photoList) {
                state.listTab.push({
                    name: '基本照片',
                    id: 'basePhoto',
                    num: 0,
                    photoList: photoList
                })
                state.swiperPhotoList = state.swiperPhotoList.concat(photoList);
            }
            if (paintPhotoList) {
                state.listTab.push({
                    name: '漆面照片',
                    id: 'paintPhoto',
                    num: 0,
                    photoList: paintPhotoList
                })
                state.swiperPhotoList = state.swiperPhotoList.concat(paintPhotoList);
            }
            if (markPhotoList) {
                state.listTab.push({
                    name: '留痕照片',
                    id: 'markPhoto',
                    num: 0,
                    photoList: markPhotoList
                })
                state.swiperPhotoList = state.swiperPhotoList.concat(markPhotoList);
            }
            // 整理照片列表
            state.listTab.forEach((item: any) => {
                if (item.id === 'basePhoto') {
                    item.photoList = photoList;
                    item.num = photoList.length;
                    state.photoList = photoList;
                }
                if (item.id === 'paintPhoto') {
                    item.photoList = paintPhotoList && paintPhotoList !== null ? paintPhotoList : [];
                    item.num = paintPhotoList && paintPhotoList !== null ? paintPhotoList.length : 0;
                }
                if (item.id === 'markPhoto') {
                    item.photoList = markPhotoList && markPhotoList !== null ? markPhotoList : [];
                    item.num = markPhotoList && markPhotoList !== null ? markPhotoList.length : 0;
                }
            })
            // 获取当前设备高度用于设置黑色背景高度
            onMounted(() => {
                state.clientHeight = document.documentElement.clientHeight
            })
            return {
                state,
                urlConversion
            }
        },
        methods: {
            /**
             * 点击切换tab
             */
            changePhotoType(tab: string) {
                if (this.state.actTab === tab) {
                    return
                }
                this.state.actTab = tab
                for (let i = 0; i < this.state.listTab.length; i++) {
                    let item = this.state.listTab[i];
                    if ((item as any).id === this.state.actTab) {
                        this.state.photoList = item.photoList
                        return;
                    }
                }
            },
            /**
             * 点击展示当前照片轮播图组件
             * */
            showSwiper(item: any) {
                let index = 0;
                for (let i = 0; i < this.state.swiperPhotoList.length; i++) {
                    let photo = this.state.swiperPhotoList[i];
                    if (photo.photoIdStr === item.photoIdStr) {
                        index = i
                        break
                    }
                }
                this.state.initialSlide = index;
                this.state.backFun = 'hiddenSwiperByTitle'
                this.state.isShowSwiper = true;
            },
            /**
             * 展示轮播图时点击左上角
             * */
            hiddenSwiperByTitle(){
                this.state.isShowSwiper = false;
                this.state.backFun = ''
            },
            /**
             * 监听全部
             */
            allPhont(data: boolean){
                this.state.isShowSwiper = false
                this.state.isAll = data
            }
        },
        components: {
            pageTitle, 
            photoListAll
        }
    })
